module.exports = __webpack_public_path__ + "static/media/program4.dd01b4fa.jpg";